<script>
  export let data = null;
  export let invalidhazard = false;
</script>

<style>
  .item-display {
    display: flex;
  }

  .icon {
    width: 64px;
    font-size: 8px;
  }
  .icon img {
    width: 100%;
  }

  .content {
    flex: 1;
    margin-left: 15px;
  }
</style>

<div class="item-display">
  {#if data}
    <div class="icon">
      {#if data.icon}
        {#if invalidhazard}
          <i class="fa fa-exclamation-circle text-danger"></i>
        {/if}
        <img src={data.icon.url} alt={data.icon.name} />
      {/if}
    </div>
    <div class="content">
      <div class="code">{data.code ? data.code : ''}</div>
      <div class="name">{data.name ? data.name : ''}</div>
      <div class="description">
        {data.description ? data.description : ''}
      </div>
    </div>
  {/if}
</div>
